import React from 'react';
import {IconProps} from './types';

export const Share = ({width, height, color, ...props}: IconProps) => {
    return (
        <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="0.5" y="0.5" width="39" height="39" rx="7.5" stroke="#BCBCCC"/>
            <path d="M20.6668 14.668V17.3346C16.2835 18.02 14.6535 21.86 14.0001 25.3346C13.9755 25.472 17.5895 21.36 20.6668 21.3346V24.0013L26.0001 19.3346L20.6668 14.668Z" stroke="#BCBCCC" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
    );
};
